<template>
    <div class="row">
        <div class="form-group col-12 px-0">
            <div class="input-group">
                <div class="col-6 col-md-4">
                    <dropdown :load-by-parent-sort="true"
                              :parent-sort="nomenclature.PersonIdentificationType"
                              :required="required"
                              :disabled="disabled"
                              :fieldName="$t('person.egn')"
                              v-model="identification.identificationTypeId"></dropdown>
                </div>
                <div class="col-6 col-md-8">
                    <input type="text" class="form-control"
                           v-model="identification.number"
                           :name="'identificationNumber' + _uid"
                           :data-vv-as="$t('person.identification')"
                           v-validate="validatorRules"
                           @change="validateNumber"
                           :readonly="disabled"/>
                    <span class="text-danger">{{ errors.first('identificationNumber' + _uid) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Dropdown from '../dropdown/NomenclatureDropdown';
    import { PersonIdentification } from '@/models/models';
    import { IdentificationTypes, GenderTypes, NomenclatureParentBySort } from '@/models/enums';

    export default {
        inject: ['$validator'],
        props: {
            identification: {
                type: Object,
                default: new PersonIdentification({})
            },
            required: {
                default: false,
                type: Boolean
            },
            disabled: {
                type: Boolean,
                default: false
            },
            validateUniqueIdNumber: {
                type: Boolean,
                default: true
            },
            validateEgn: {
                type: Boolean,
                default: false
            },
            profileData: {
                type: Object,
                default() {
                    return null;
                }
            }
        },
        data() {
            return {
                nomenclature: NomenclatureParentBySort,
                oldIdentificationNumber: '',
                isDifferentIdentificationNumber: false,
                isMountedIdentificationNumber: false,
                queryString: '',
                isUnique: false
            }
        },
        components: {
            Dropdown
        },
        created() {
            this.$validator.extend('isUniqueNumber', {
                getMessage: () => `${this.$t('isNotUniqueNumber')}`,
                validate: value => this.$http.get(`/api/Person/IsIdentificationNumberUnique${this.queryString}`).then(
                    result => {
                        value = result.data;
                        return value;
                    }).catch(error => {
                })
            })
            this.$validator.extend('isValidEgn', {
                getMessage: () => `${this.$t('isNotValidEgn')}`,
                validate: value => this.$http.get(`/api/Person/isEgnValid`, { params: this.egnValidatonRequestParams }).then(
                    result => {
                        value = result.data;
                        return value;
                    }).catch(error => {
                })
            })
        },
        mounted: function () {
            this.isMountedIdentificationNumber = true;
        },
        methods: {
            validateNumber(event) {
                if (this.identification.identificationTypeId === IdentificationTypes.EGN) {
                    // TODO: Validate EGN
                    this.emitGenderType();
                } else if (this.identification.identificationTypeId === IdentificationTypes.Foreigner) {
                    // TODO:
                }
            },
            emitGenderType() {
                const genderNumber = Math.floor(parseInt(this.identification.number) / 10 % 10);
                if (genderNumber % 2 === 0) {
                    this.$emit('getGenderTypeId', GenderTypes.Male);
                } else {
                    this.$emit('getGenderTypeId', GenderTypes.Female);
                }
            }
        },
        computed: {
            validatorRules() {
                let str = '';
                if (this.required) {
                    str += 'required|';
                }

                if (this.validateUniqueIdNumber && this.isDifferentIdentificationNumber) {
                    str += 'isUniqueNumber|';
                }

                if (this.validateEgn && this.isDifferentIdentificationNumber) {
                    str += 'isValidEgn|';
                }

                return str;
            },
            egnValidatonRequestParams() {
                let params = {
                    identificationType: null,
                    number: null
                }

                if (this.identification) {
                    params.identificationType = this.identification.identificationTypeId;
                    params.number = this.identification.number;
                }

                return params;
            }
        },
        watch: {
            'identification.number'(newVal, oldVal) {
                if (this.isMountedIdentificationNumber) {
                    this.oldIdentificationNumber = newVal;
                    this.isMountedIdentificationNumber = false;
                }

                if (newVal === this.oldIdentificationNumber) {
                    this.isDifferentIdentificationNumber = false;
                } else {
                    this.isDifferentIdentificationNumber = true;
                }

                if (this.identification.id) {
                    this.queryString = `/${this.identification.number}/${this.identification.id}`;
                } else {
                    this.queryString = `/${this.identification.number}`;
                }
            }
        },
    }
</script>

<style scoped>
</style>
